module.exports = "class Movie\n{\n    const ROOM_ROWS = 5;\n    const SEATS_PER_ROW = 5;\n\n    //...\n\n    public function getAvailableSeats()\n    {\n        return Movie::ROOM_ROWS * Movie::SEATS_PER_ROW - count($this->tickets);\n    }\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/entity-movie-numseats.txt
// module id = 638
// module chunks = 94772797177096